module.exports = __webpack_public_path__ + "static/media/summary.1206cd45.md";